// extracted by mini-css-extract-plugin
export default {"container":"Team_container__Aar49","heading":"Team_heading__3xMVJ","content":"Team_content__xeOtw"};